import React from "react";

import ManuscriptTextEditorHost from "components/organisms/manuscript/ManuscriptTextEditorHost";

function ManuscriptCodeEditor(props) {
    return (
        <ManuscriptTextEditorHost
            {...props}
            basicSetup={{
                drawSelection: false,
                foldGutter: true,
                highlightActiveLine: true,
                highlightActiveLineGutter: true,
                highlightSelectionMatches: false,
                lineNumbers: true,
                searchKeymap: true,
            }}
        />
    );
}

export default ManuscriptCodeEditor;
